import { render } from "./ContactGuest.vue?vue&type=template&id=2703cb61"
import script from "./ContactGuest.vue?vue&type=script&lang=js"
export * from "./ContactGuest.vue?vue&type=script&lang=js"
script.render = render

export default script